import { LARGER } from './breakpoint-controller'
let header , anchorBar, anchorLink , layout , win , containerTop , stickyNav;
function onDocumentReady() {
    win = $(window);
    anchorBar = $('.layout-anchorbar');
    layout = $('.layout');
    anchorLink = anchorBar.find('.anchor');
    header = $('#header');
    stickyNav = anchorBar.find('.anchor-list');

    if(anchorBar.length){
        layout.each(function() {
            var tabTitle = $(this).data('tab');
            var tabSlug = $(this).attr('id');
            if(tabTitle){
                $('<a href="#'+tabSlug+'" class="anchor-link">'+tabTitle+'</a> ').appendTo('.layout-anchorbar .anchor-list').wrap('<li class="anchor"></li>');
            }
        });
    }
    $(window).on('load scroll', function(){
        if($(window).width() >= LARGER){
            if ($(this).scrollTop() >= 100) {
                header.addClass('sticky');
            }
            else{
                header.removeClass('sticky');
            }
        }
        if(anchorBar.length){
            if (win.width() >= LARGER) {
                onWindowScroll();
            }
        }
    });
}

function onWindowScroll() {
    let scroll = win.scrollTop();
    let headerOffset = (header.length) ? parseInt(header.outerHeight()) : 0;
    let refElement;
    containerTop = anchorBar.offset().top - headerOffset + 43;
    anchorBar.find('.anchor-link').each(function () {
        let currLink = $(this);
        refElement = $($(this).attr("href"));
        if (refElement.offset().top - 200 <= scroll && refElement.offset().top + refElement.height() > scroll) {
            anchorLink.removeClass('active-link');
            currLink.closest('.anchor').addClass("active-link");
        }
        else{
            currLink.closest('.anchor').removeClass("active-link");
        }
    });

    if (scroll >= containerTop) {
        affix();
    }
    else{
        unaffix();
    }
}
//fixes sub nav to the top of the viewport
function affix() {
    stickyNav.addClass('anchor-block-sticky');
}

//removes fixed positioning of sub nav
function unaffix() {
    stickyNav.removeClass('anchor-block-sticky');
}

$(document).on('click','a[href*="#"]:not([href="#"])',function(e){
    e.preventDefault();
    var target = $(this.hash);
    anchorLink.removeClass('active-link');
    $(this).closest('.anchor').addClass('active-link');
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - 60
        }, 1000);
        return false;
    }
});

document.addEventListener('DOMContentLoaded', onDocumentReady);



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/anchorbar-controller.js